import type { LucideIcon } from 'lucide-react'
import * as React from 'react'
import { forwardRef } from 'react'

export const BookRowLeftChevronIcon: LucideIcon = forwardRef(({ size = 39, color = '#D5E7F8', ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(Number(size) * 154) / 39}
      viewBox='0 0 39 154'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M0.791125 79.0583C0.281074 77.6992 0.281075 76.2012 0.791126 74.8421L27.3825 3.98413C29.7292 -2.26901 39 -0.586731 39 6.09224L39 147.808C39 154.487 29.7292 156.169 27.3825 149.916L0.791125 79.0583Z'
        fill={color}
      />
    </svg>
  )
})

BookRowLeftChevronIcon.displayName = 'BookRowLeftChevronIcon'
